import {addSpanTagToString} from "./addSpanTagsToBody";
import { getEntityPatterns } from "./emptyEntities";

export function checkInlineEntities(value: string, currentEntityKW: string, otherEntities: any[]): string {
    for (let entity of otherEntities) {
        let {normalPattern, escapedPattern, rawPattern} = getEntityPatterns(entity.keyword)
        if (rawPattern == currentEntityKW) {
            continue
        }
        value = addSpanTagToString(entity, value)
    }
    return value
}